import { Eye, EyeOff } from "lucide-react";

export const fmtSeen = (at) => {
  try { return new Date(at).toLocaleString("ar-SA-u-nu-latn-ca-gregory", { dateStyle: "short", timeStyle: "short" }); } catch { return at; }
};

export const SeenLine = ({ items, showPending, testId }) => {
  const list = items || [];
  if (!list.length) return showPending ? (
    <p className="mt-1.5 flex items-center gap-1 text-[11px] text-slate-400" data-testid={testId}><EyeOff className="h-3.5 w-3.5" /> لم تُفتح بعد</p>
  ) : null;
  return (
    <p className="mt-1.5 flex flex-wrap items-center gap-1 text-[11px] text-sky-700" data-testid={testId}>
      <Eye className="h-3.5 w-3.5" /> فُتحت: {list.map((x) => `${x.name} — ${fmtSeen(x.at)}`).join("، ")}
    </p>
  );
};
